import React from 'react';
import './ThankYouComponent.scss';
import { BookAppointment1 } from '@/assets/img/BookAppointment-1';
import { Button } from '@/components/Elements';
type ThankYouComponentProps = {
  onBackClicked: () => void;
};

const ThankYouComponent = ({ onBackClicked }: ThankYouComponentProps) => {
  return (
    <div className="intake-form-thank-you">
      <div className="thank-you-card">
        <BookAppointment1 />
        <h5 className="title">Intake form has been submitted successfully.</h5>
        <p>If you want to submit the intake form again , please click the button below.</p>
        <Button variant="inverse" size="lg" onClick={onBackClicked}>
          Back to Intake form
        </Button>
      </div>
    </div>
  );
};

export default ThankYouComponent;
